<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline mb-3">
          <span class="font-weight-bold d-flex align-center">
            <v-icon class="mr-3 black--text" @click="goBack()">
              mdi-arrow-left
            </v-icon>
            {{ $t('menu') }}
          </span>
        </h2>
        <div class="d-flex align-center">
          <v-text-field :label="$t('search')" prepend-inner-icon="mdi-magnify" height="40" dense hide-details outlined clearable @input="searchProduct" @click:clear="clearSearchData" />
          <div class="col-filter-view">
            <div class="d-flex align-centter">
              <div class="ml-2">
                <v-btn icon :class="[`br-5 btn-filter`]" @click="is_list = !is_list">
                  <v-icon v-if="!is_list">
                    mdi-format-list-bulleted
                  </v-icon>
                  <v-icon v-else>
                    mdi-view-grid-outline
                  </v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row class="__list-product">
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <div v-scroll="onScrollCombo" :class="[{'mb-8': !loading}, { 'd-none': searching || datacombos.length === 0 }]">
          <div v-if="datacombos.length !== 0" id="combo_product" class="__item-product">
            <list-product-combo
              :is-list="is_list"
              :products="datacombos"
              :title="$t('combo')"
              :showdata="showDetail"
              :view-image="showImage"
            />
          </div>
        </div>
        <div v-scroll="onScrollSearch" :class="[{'mb-8': !loading}, { 'd-none': !searching }]">
          <div v-for="(item, idx) in productSearch" :key="idx + '-item-product'" class="__item-product">
            <list-product
              v-if="item.items.length !== 0"
              :is-list="is_list"
              :products="item.items"
              :title="item.product_group_name"
              :showdata="showDetailProduct"
              :view-image="showImage"
            />
          </div>
        </div>
        <div v-scroll="onScrollProduct" :class="[{'mb-8': !loading}, { 'd-none': searching }]">
          <div v-for="(item, idx) in productGroup" :id="'product_' + item.product_group_id" :key="idx + '-item-product'" class="__item-product">
            <list-product
              v-if="item.items.length !== 0"
              :is-list="is_list"
              :products="item.items"
              :title="item.product_group_name"
              :showdata="showDetailProduct"
              :view-image="showImage"
            />
          </div>
        </div>
        <CustomSkeletonList v-if="loading && is_list" :is-first="isFirst" />
        <CustomSkeletonGrid v-if="loading && !is_list" :is-first="isFirst" />
      </v-col>

      <v-bottom-sheet v-model="sheetDetail" persistent :content-class="'product__detail'">
        <v-sheet style="height: 100%">
          <v-form id="addCartItems" @submit.prevent="addCartProduct()">
            <v-container fluid>
              <v-row class="ma-0">
                <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0">
                  <v-btn text icon color="red lighten-2" @click="closeShowDetail()">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
                  <v-list class="list-product py-0">
                    <v-list-item>
                      <v-list-item-avatar class="list-img-square image-detail" @click="showImage(photo_product)">
                        <img :src="photo_product" :alt="productDetails.name" @error="imageLoadError">
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title v-html="productDetails.name" />
                        <v-list-item-title v-if="productDetails.alt_name" v-html="productDetails.alt_name" />
                        <v-list-item-subtitle v-if="(Number(productDetails.pos_sell_price_dynamic) === 1 && Number($store.state.selected_outlet.setting.pos_dynamic_price_can_order) === 1) || Number(productDetails.pos_sell_price_dynamic) === 0" v-mask-money="formProduct.sell_price" class="font-weight-bold title subtitle-2" />
                      </v-list-item-content>
                    </v-list-item>

                    <div v-if="Number(productDetails.pos_sell_price_dynamic) === 1 && Number($store.state.selected_outlet.setting.pos_dynamic_price_can_order) === 0" class="d-flex px-7 py-4 section-dynamic-order">
                      <div class="section-dynamic-order-avatar">
                        <v-img src="@/assets/images/order_cashier.png" :aspect-ratio="1/1" width="80" />
                      </div>
                      <div class="section-dynamic-order-content">
                        <div class="section-dynamic-order-content-title">
                          {{ $t('order_at_the_cashier') }}
                        </div>
                        <div class="section-dynamic-order-content-subtitle">
                          {{ $t('product_only_be_ordered_at_the_cashier') }}
                        </div>
                      </div>
                    </div>

                    <template v-if="productDetails.description">
                      <v-divider />
                      <v-list-item class="__detail-description" @click="more_description = !more_description">
                        <v-list-item-content>
                          <v-list-item-subtitle :class="['animate-fade', { 'more-description-detail': more_description }]">
                            <div v-html="html_description" />
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider />
                    </template>
                  </v-list>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0 margin-bottom-addtocart">
                  <v-row v-if="productDetails.items && productDetails.items.length !== 0 && !$store.state.selected_outlet.hide_combo_item" class="ma-0">
                    <v-col cols="12" class="px-0">
                      <h4 class="title">
                        <span class="font-weight-bold grey--text">{{ $t('item_detail') }}</span>
                      </h4>
                      <template v-for="(child, idx) in productDetails.items">
                        <template v-if="child.children.length !== 0">
                          <v-select :key="idx + '-item-variant-id'" v-model="combo_items.id[idx]" :items="commodity[idx]" item-text="name" item-value="id" item-disabled="disabled" hide-details solo class="mb-2" @change="selectComboItem(idx)">
                            <template v-slot:selection="{ item }">
                              {{ parseFloat(item.qty) + 'x' }} {{ item.name }}
                            </template>
                          </v-select>
                        </template>
                        <template v-else-if="child.children.length === 0 && child.product_has_variant">
                          <v-select :key="idx + '-item-variant-id'" v-model="combo_items.id[idx]" :items="commodity[idx]" item-text="name" item-value="id" item-disabled="disabled" hide-details solo class="mb-2" @change="selectComboItem(idx)">
                            <template v-slot:selection="{ item }">
                              {{ parseFloat(item.qty) + 'x' }} {{ item.name }}
                            </template>
                          </v-select>
                        </template>
                        <template v-else>
                          <input :key="idx + '-item-id'" type="hidden" :value="combo_items.id[idx]">
                          <v-text-field :key="idx + '-item-variant-id'" :label="child.qty + 'x ' + child.product_name + (child.product_variant_name !== null ? ' - ' + child.product_variant_name : '')" disabled hide-details solo class="mb-2" />
                        </template>
                      </template>
                    </v-col>
                  </v-row>
                  <v-row v-if="productDetails.variants && productDetails.variants.length !== 0" class="ma-0">
                    <v-col cols="12" class="px-0">
                      <h4 class="title mb-4">
                        <span class="font-weight-bold grey--text">{{ $t('variant') }}</span>
                      </h4>
                      <div v-for="(variant, idx) in productDetails.variant_tag" :key="idx" class="row-variant-tag">
                        <div class="title-variant-tag">
                          {{ variant.label }}
                        </div>
                        <v-radio-group v-model="variant_group[idx]" hide-details class="mt-0 list-variant-tag" @change="selectVariant()">
                          <v-radio v-for="(detail, i) in variant.detail" :key="i" :label="detail" :value="detail" class="list-variant-tag-item" />
                        </v-radio-group>
                        <hr v-if="productDetails.variant_tag.length !== idx + 1" class="my-4 hr-dashed">
                      </div>
                    </v-col>
                  </v-row>
                  <v-divider class="my-4 divider-row" />
                  <v-row v-if="productDetails.addons && productDetails.addons.length !== 0" class="ma-0">
                    <v-col cols="12" class="px-0 pt-0">
                      <h4 class="title">
                        <span class="font-weight-bold grey--text">{{ $t('add_ons') }}</span>
                      </h4>
                      <v-list class="list-addons black--text">
                        <template v-for="(item, idx) in productDetails.addons">
                          <v-list-item v-if="item.product_status !== 'X'" :key="idx + '-product-addons'">
                            <v-list-item-content>
                              <v-list-item-title>
                                <span v-if="added_addons[item.id] === true" class="primary--text font-weight-bold">
                                  {{ item.name }}
                                </span>
                                <span v-else class="black--text">
                                  {{ item.name }}
                                </span>
                              </v-list-item-title>
                              <v-list-item-subtitle v-mask-money="(item.total_price != null ? item.total_price : item.price)" class="font-weight-bold black--text darken-4 text-right" />
                            </v-list-item-content>
                            <v-list-item-action class="__addons-action">
                              <v-btn v-if="added_addons[item.id] === true" text x-small color="primary" class="text-none" @click="removeProductAddons(item.id, (item.total_price != null ? item.total_price : item.price), idx)">
                                {{ $t('remove') }}
                              </v-btn>
                              <v-btn v-else x-small color="primary" class="text-none" @click="addProductAddons(item, idx)">
                                {{ $t('add') }}
                              </v-btn>
                            </v-list-item-action>
                          </v-list-item>
                        </template>
                      </v-list>
                    </v-col>
                  </v-row>
                  <v-row class="ma-0">
                    <v-col cols="12" class="px-0 pt-0">
                      <v-text-field v-model="formProduct.note" solo hide-details :label="$t('add_note')" prepend-inner-icon="mdi-file-document-outline" :append-icon="list_note.length !== 0 ? 'mdi-dots-vertical' : ''" @click:append="openDialogNote" @focus="noteOnFocus()" @blur="noteOnBlur()" />
                    </v-col>
                  </v-row>
                </v-col>

                <input type="hidden" :value="formProduct.sell_price">
                <div v-if="(Number(productDetails.pos_sell_price_dynamic) === 1 && Number($store.state.selected_outlet.setting.pos_dynamic_price_can_order) === 1) || Number(productDetails.pos_sell_price_dynamic) === 0" class="sec_add__to__cart">
                  <v-container fluid class="pa-0">
                    <v-row class="ma-0">
                      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0">
                        <div class="text-center">
                          <div class="d-flex align-center justify-center mb-3">
                            <v-btn color="primary" fab outlined :disabled="disabled" x-small @click="minus()">
                              <v-icon>mdi-minus</v-icon>
                            </v-btn>
                            <p class="px-2 my-0">
                              {{ formProduct.qty }}
                            </p>
                            <v-btn color="primary" fab outlined x-small @click="plus()">
                              <v-icon>mdi-plus</v-icon>
                            </v-btn>
                          </div>
                          <v-btn large color="primary" :disabled="disable_add_cart" width="100%" type="submit" form="addCartItems">
                            {{ $t('add_to_cart') }}
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </div>
              </v-row>
            </v-container>
          </v-form>
        </v-sheet>
      </v-bottom-sheet>

      <menu-product :show-combo="datacombos.length > 0" :class="{ 'hasItemCart': dataInCart.item.length !== 0 }" />
      <item-cart v-if="dataInCart.item.length !== 0" :qtyincart="incart.qty" :price="incart.sub_total" />
    </v-row>

    <v-dialog v-model="dialog.qtyCheck" max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ $t('failed_add_to_cart') }}
        </v-card-title>
        <v-card-text>
          <div v-if="error_from_validate">
            {{ error_string_from_validate }}
          </div>
          <div v-else>
            {{ $t('product_quantity_exceeds_stock', { product_name: unavailable_product }) }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" text @click="dialog.qtyCheck = false">
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.isOutStock" max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ $t('failed_add_to_cart') }}
        </v-card-title>
        <v-card-text>
          {{ $t('product_is_out_stock', { product_name: unavailable_product }) }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" text @click="dialog.isOutStock = false">
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.variantNotAvailable" max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ $t('variant_not_available') }}
        </v-card-title>
        <v-card-text>
          {{ $t('please_select_another_variant') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" text @click="dialog.variantNotAvailable = false">
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.product_unpublished" max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ $t('failed_add_to_cart') }}
        </v-card-title>
        <v-card-text>
          {{ $t('products_have_not_been_published', { product_name: unavailable_product }) }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" text @click="dialog.product_unpublished = false">
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.view_image" max-width="400">
      <v-card class="card-view-image">
        <v-card-text>
          <v-btn fab x-small color="white" class="btn-close-view-img" @click="closeShowImage">
            <v-icon dark>
              mdi-close
            </v-icon>
          </v-btn>
          <v-img :src="dataproduct_image" :aspect-ratio="1/1" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.list_note" max-width="290">
      <v-card class="card-view-image">
        <v-card-text>
          <template v-if="list_note.length > 0">
            <v-checkbox v-for="(item, idx) in list_note" :key="idx" v-model="listnote[idx]" :label="item" solo hide-details />
          </template>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" text class="text-none" @click="dialog.list_note = false">
            {{ $t('close') }}
          </v-btn>
          <v-btn color="primary" text class="text-none" @click="saveNote">
            {{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.maxMinOrder" max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ $t('failed_add_to_cart') }}
        </v-card-title>
        <v-card-text>
          {{ orderErrorMessage }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" text @click="dialog.maxMinOrder = false">
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  getData as getDataProduct,
  getDetail as getDetailProduct,
  getDataCombo as getDataProductCombo,
  getDetailCombo as getDetailProductCombo,
  checkMaterial as checkStockMaterial,
  validateMaterial
} from '@/api/product'
import { debounce } from 'debounce'
import listProduct from '@/components/modules/product/ListProduct'
import listProductCombo from '@/components/modules/product/ListProductCombo'
import menuProduct from '@/components/modules/menu/MenuProduct'
import itemCart from '@/components/modules/menu/ItemCart'
import CustomSkeletonList from '@/components/modules/CustomSkeleton/list'
import CustomSkeletonGrid from '@/components/modules/CustomSkeleton/grid'
export default {
  components: {
    listProduct,
    listProductCombo,
    menuProduct,
    itemCart,
    CustomSkeletonList,
    CustomSkeletonGrid
  },
  data() {
    return {
      is_list: true,
      loading: false,
      more_description: false,
      html_description: '',
      settingScroll: {
        product: false,
        search: false,
        combo: false
      },
      params: {
        combo_page: 1,
        combo_per_page: 20,
        page: 1,
        per_page: 20
      },
      disabled: true,
      productGroup: [],
      productSearch: [],
      added_addons: [],
      datacombos: [],
      dataproducts: [],
      productDetails: {},
      sheetDetail: false,
      temporary: {
        products_variant_name: []
      },
      commodity: [],
      combo_items: {
        id: [],
        name: [],
        qty: [],
        stock_qty: [],
        hold_qty: [],
        is_out_stock: [],
        track_inventory: [],
        published: []
      },
      dataCheckout: {
        item: []
      },
      dataInCart: {
        item: []
      },
      list_note: [],
      listnote: [],
      formProduct: {
        product_id: null,
        name: '',
        product_variant_id: null,
        product_variant_name: null,
        note: '',
        addons: [],
        product_combo_id: null,
        product_combo_items: [],
        qty: 0,
        sell_price: 0,
        track_inventory: 0,
        stock_qty: 0,
        hold_qty: 0,
        sub_total: 0,
        non_taxable: 0,
        non_service_charge: 0,
        has_material: 0,
        materials: []
      },
      sub_total: 0,
      formSearch: {
        name_product: ''
      },
      searching: false,
      search_text: '',
      dialog: {
        qtyCheck: false,
        view_image: false,
        product_unpublished: false,
        list_note: false,
        isOutStock: false,
        variantNotAvailable: false,
        maxMinOrder: false
      },
      unavailable_product: '',
      dataproduct_image: '',
      variant_group: [],
      variant_alt_group: [],
      variant_is_not_available: false,
      photo_product: '',
      disable_add_cart: false,
      temp_cart: {},
      materialRequestId: 0,
      error_from_validate: 0,
      error_string_from_validate: '',
      orderErrorMessage: ''
    }
  },
  computed: {
    isFirst() {
      return this.params.page === 1 || this.params.combo_page === 1
    },
    'incart': function() {
      if (this.dataInCart.item && this.dataInCart.item.length) {
        return this.dataInCart.item.reduce((acc, curr) => {
          return {
            qty: acc.qty + curr.qty,
            sub_total: acc.sub_total + curr.sub_total
          }
        })
      } else {
        return {
          qty: 0,
          sub_total: 0
        }
      }
    },
    loadedProductGroupIds() {
      const ids = []
      if (this.productGroup.length) {
        this.productGroup.map(item => {
          ids.push(item.product_group_id)
        })
        return ids
      }
      return ids
    },
    loadedProductSearchIds() {
      const ids = []
      if (this.productSearch.length) {
        this.productSearch.map(item => {
          ids.push(item.product_group_id)
        })
        return ids
      }
      return ids
    },
    inCartProductIds() {
      const arr = []
      if (this.dataInCart.item.length) {
        this.dataInCart.item.map(item => {
          if (item.product_id) {
            arr.push(item.product_id)
          }
        })
        return arr
      }
      return arr
    },
    inCartComboIds() {
      const arr = []
      if (this.dataInCart.item.length) {
        this.dataInCart.item.map(item => {
          if (item.product_combo_id) {
            arr.push(item.product_combo_id)
          }
        })
        return arr
      }
      return arr
    }
  },
  watch: {
    'formProduct.qty': function(newItem, oldItem) {
      if (newItem <= 1) {
        this.disabled = true
      } else {
        this.disabled = false
      }
    }
  },
  created() {
    this.$store.dispatch('saveSelectedType', 'OL-TAKE-AWAY')
    this.loadProductCombo()
    // this.loadGroupProduct()
  },
  mounted() {
    const LOCAL_DATA_CartTakeAway = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_OL-TAKE-AWAY')
    if (LOCAL_DATA_CartTakeAway) {
      this.dataInCart = JSON.parse(LOCAL_DATA_CartTakeAway)
    }
  },
  methods: {
    imageLoadError(event) {
      event.target.src = require('@/assets/images/product_not_available.png')
    },
    onScrollCombo: debounce(async function() {
      if (this.settingScroll.combo === false) {
        if ((window.innerHeight + window.scrollY + 150) >= document.body.offsetHeight) {
          this.loadProductCombo()
        }
      }
    }, 500),
    onScrollProduct: debounce(async function() {
      if (this.settingScroll.product === false) {
        if ((window.innerHeight + window.scrollY + 150) >= document.body.offsetHeight) {
          this.loadGroupProduct()
        }
      }
    }, 500),
    onScrollSearch: debounce(async function() {
      if (this.settingScroll.search === false) {
        if ((window.innerHeight + window.scrollY + 150) >= document.body.offsetHeight) {
          this.loadDataSearch()
        }
      }
    }, 500),
    async loadGroupProduct() {
      try {
        this.loading = true
        const params = {
          page: this.params.page++,
          per_page: this.params.per_page
        }
        const { data } = await getDataProduct(params)
        this.settingScroll.product = (data.data.length < this.params.per_page)
        this.$store.state.loading_axios = false
        const data_product = data.data
        await data_product.map(item => {
          let is_available = true
          if (item.has_variant === 0) {
            if (item.track_inventory !== 0) {
              if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                if (Number(item.stock_qty) <= 0) {
                  is_available = false
                } else {
                  is_available = true
                }
              } else {
                is_available = true
              }
            }
          }
          this.$set(item, '__cart_data', { qty: 0, note: '', is_available: is_available })
          this.syncProduct(item, 'product')
          if (!this.loadedProductGroupIds.includes(item.klasifikasi_id)) {
            this.productGroup.push({
              product_group_id: item.klasifikasi_id,
              product_group_name: item.klasifikasi,
              items: data_product.filter(__data => __data.klasifikasi_id === item.klasifikasi_id)
            })
          } else {
            const productGroup = this.productGroup.filter(group => {
              return item.klasifikasi_id === group.product_group_id
            })
            const index = productGroup[0].items.findIndex((e) => e.id === item.id)
            if (index === -1) {
              productGroup[0].items.push(...data_product.filter(__data => __data.klasifikasi_id === item.klasifikasi_id))
            }
          }
        })
      } catch (e) {
        this.settingScroll.product = true
        this.productGroup = []
        // this.$store.state.show_error = true
        // this.$store.state.error_message = e.string
        // this.$store.state.error_type = e.statusCode
      } finally {
        this.loading = false
      }
    },
    async loadProductCombo() {
      try {
        this.loading = true
        const params = {
          page: this.params.combo_page++,
          per_page: this.params.combo_per_page,
          sort_column: 'published_date',
          sort_type: 'asc'
        }
        const { data } = await getDataProductCombo(params)
        this.settingScroll.combo = (data.data.length < this.params.combo_per_page)
        this.$store.state.loading_axios = false
        data.data.map(item => {
          let is_available = true
          if (item.is_out_stock) {
            is_available = false
          }
          this.$set(item, '__cart_data', { qty: 0, note: '', is_available: is_available })
          this.syncProduct(item, 'product_combo')
          this.datacombos.push({ ...item })
        })
        if (this.datacombos.length === data.meta.total) {
          await this.loadGroupProduct()
        }
      } catch (e) {
        if (e.statusCode === 404) {
          await this.loadGroupProduct()
        }
        this.settingScroll.combo = true
        this.datacombos = []
      } finally {
        this.loading = false
      }
    },
    showImage(item_product) {
      this.dialog.view_image = true
      this.dataproduct_image = item_product
    },
    closeShowImage() {
      this.dialog.view_image = false
      this.dataproduct_image = ''
    },
    async showDetail(item_product) {
      if (Number(item_product.is_out_stock) !== 1) {
        this.resetForm()
        try {
          const { data } = await getDetailProductCombo(item_product.id)
          this.$store.state.loading_axios = false
          this.productDetails = data.data
          this.photo_product = data.data.photo_md
          if (this.productDetails.description) {
            this.html_description = (this.productDetails.description).replace(/\n/g, '<br />')
          } else {
            this.html_description = ''
          }
          this.sheetDetail = !this.sheetDetail
          document.querySelector('html').style.overflowY = 'hidden'
          this.formProduct.product_combo_id = item_product.id
          this.formProduct.product_id = null
          this.formProduct.qty = 1
          this.formProduct.name = this.productDetails.name
          this.formProduct.sell_price = parseFloat(this.productDetails.sell_price)
          this.formProduct.non_taxable = this.productDetails.non_taxable
          this.formProduct.non_service_charge = 0
          this.formProduct.track_inventory = this.productDetails.track_inventory
          this.formProduct.klasifikasi_id = null
          this.formProduct.max_order = Number(this.productDetails.max_order)
          this.formProduct.min_order = Number(this.productDetails.min_order)
          this.sub_total = this.formProduct.sell_price

          // eslint-disable-next-line
          //set default variant
          await this.productDetails.items.map((item, idx) => {
            this.combo_items.id[idx] = item.id + ',' + ','
            this.combo_items.name[idx] = item.product_name
            this.combo_items.qty[idx] = Number(item.qty)
            this.combo_items.stock_qty[idx] = Number(item.stock_qty)
            this.combo_items.hold_qty[idx] = Number(item.hold_qty)
            this.combo_items.is_out_stock[idx] = item.product_is_out_stock
            this.combo_items.track_inventory[idx] = item.product_track_inventory
            this.combo_items.published[idx] = item.published
            if (item.children.length !== 0) {
              this.commodity[idx] = []
              if (item.product_has_variant) {
                if (item.product_variant_id) {
                  const result = item.variant.find(obj => {
                    return obj.id === item.product_variant_id
                  })
                  this.combo_items.name[idx] = item.product_name + ' (' + result.name + ')'
                  this.combo_items.stock_qty[idx] = Number(result.stock_qty)
                  this.combo_items.hold_qty[idx] = Number(result.hold_qty)
                  this.combo_items.is_out_stock[idx] = result.is_out_stock
                  this.combo_items.id[idx] = item.id + ',' + item.product_variant_id + ','
                } else {
                  this.combo_items.name[idx] = item.product_name + ' (' + item.variant[0].name + ')'
                  this.combo_items.stock_qty[idx] = Number(item.variant[0].stock_qty)
                  this.combo_items.hold_qty[idx] = Number(item.variant[0].hold_qty)
                  this.combo_items.is_out_stock[idx] = item.variant[0].is_out_stock
                  this.combo_items.id[idx] = item.id + ',' + item.variant[0].id + ','
                }
                this.combo_items.qty[idx] = Number(item.qty)
                this.combo_items.track_inventory[idx] = item.product_track_inventory
                if (item.product_track_inventory) {
                  if (item.variant.length > 0 && item.product_variant_id === 0) {
                    for (var a in item.variant) {
                      if (!item.variant[a].is_out_stock) {
                        if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                          const stock_incart = this.$stockCart(item.product_variant_id, '_data_cart_OL-TAKE-AWAY', 'variant')
                          if (Number(item.variant[a].stock_qty) - Number(item.variant[a].hold_qty) >= (Number(item.qty) + stock_incart)) {
                            this.commodity[idx].push({
                              id: item.id + ',' + item.variant[a].id + ',',
                              name: item.product_name + ' (' + item.variant[a].name + ')',
                              disabled: false,
                              qty: Number(item.qty),
                              stock_qty: Number(item.variant[a].stock_qty),
                              hold_qty: Number(item.variant[a].hold_qty),
                              is_out_stock: item.variant[a].is_out_stock,
                              track_inventory: item.product_track_inventory,
                              published: item.published
                            })
                          } else {
                            this.commodity[idx].push({
                              id: item.id + ',' + item.variant[a].id + ',',
                              name: item.product_name + ' (' + item.variant[a].name + ')' + ' (Stock tidak mencukupi)',
                              disabled: true,
                              qty: Number(item.qty),
                              stock_qty: Number(item.variant[a].stock_qty),
                              hold_qty: Number(item.variant[a].hold_qty),
                              is_out_stock: item.variant[a].is_out_stock,
                              track_inventory: item.product_track_inventory,
                              published: item.published
                            })
                          }
                        } else {
                          this.commodity[idx].push({
                            id: item.id + ',' + item.variant[a].id + ',',
                            name: item.product_name + ' (' + item.variant[a].name + ')',
                            disabled: false,
                            qty: Number(item.qty),
                            stock_qty: Number(item.variant[a].stock_qty),
                            hold_qty: Number(item.variant[a].hold_qty),
                            is_out_stock: item.variant[a].is_out_stock,
                            track_inventory: item.product_track_inventory,
                            published: item.published
                          })
                        }
                      } else {
                        this.commodity[idx].push({
                          id: item.id + ',' + item.variant[a].id + ',',
                          name: item.product_name + ' (' + item.variant[a].name + ')' + ' (Stock tidak mencukupi)',
                          disabled: true,
                          qty: Number(item.qty),
                          stock_qty: Number(item.variant[a].stock_qty),
                          hold_qty: Number(item.variant[a].hold_qty),
                          is_out_stock: item.variant[a].is_out_stock,
                          track_inventory: item.product_track_inventory,
                          published: item.published
                        })
                      }
                    }
                  } else {
                    const result = item.variant.find(obj => {
                      return obj.id === item.product_variant_id
                    })
                    if (typeof result !== 'undefined') {
                      if (!result.is_out_stock) {
                        if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                          const stock_incart = this.$stockCart(result.id, '_data_cart_OL-TAKE-AWAY', 'variant')
                          if (Number(result.stock_qty) - Number(result.hold_qty) >= (Number(item.qty) + stock_incart)) {
                            this.commodity[idx].push({
                              id: item.id + ',' + item.product_variant_id + ',',
                              name: item.product_name + ' (' + result.name + ')',
                              disabled: false,
                              qty: Number(item.qty),
                              stock_qty: Number(result.stock_qty),
                              hold_qty: Number(result.hold_qty),
                              is_out_stock: result.is_out_stock,
                              track_inventory: item.product_track_inventory,
                              published: item.published
                            })
                          } else {
                            this.commodity[idx].push({
                              id: item.id + ',' + item.product_variant_id + ',',
                              name: item.product_name + ' (' + result.name + ')' + ' (Stock tidak mencukupi)',
                              disabled: true,
                              qty: Number(item.qty),
                              stock_qty: Number(result.stock_qty),
                              hold_qty: Number(result.hold_qty),
                              is_out_stock: result.is_out_stock,
                              track_inventory: item.product_track_inventory,
                              published: item.published
                            })
                          }
                        } else {
                          this.commodity[idx].push({
                            id: item.id + ',' + item.product_variant_id + ',',
                            name: item.product_name + ' (' + result.name + ')',
                            disabled: false,
                            qty: Number(item.qty),
                            stock_qty: Number(result.stock_qty),
                            hold_qty: Number(result.hold_qty),
                            is_out_stock: result.is_out_stock,
                            track_inventory: item.product_track_inventory,
                            published: item.published
                          })
                        }
                      } else {
                        this.commodity[idx].push({
                          id: item.id + ',' + item.product_variant_id + ',',
                          name: item.product_name + ' (' + result.name + ')' + ' (Stock tidak mencukupi)',
                          disabled: true,
                          qty: Number(item.qty),
                          stock_qty: Number(result.stock_qty),
                          hold_qty: Number(result.hold_qty),
                          is_out_stock: result.is_out_stock,
                          track_inventory: item.product_track_inventory,
                          published: item.published
                        })
                      }
                    } else {
                      if (!item.variant[0].is_out_stock) {
                        if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                          const stock_incart = this.$stockCart(item.variant[0].id, '_data_cart_OL-TAKE-AWAY', 'variant')
                          if (Number(item.variant[0].stock_qty) - Number(item.variant[0].hold_qty) >= (Number(item.qty) + stock_incart)) {
                            this.commodity[idx].push({
                              id: item.id + ',' + item.variant[0].id + ',',
                              name: item.product_name + ' (' + item.variant[0].name + ')',
                              disabled: false,
                              qty: Number(item.qty),
                              stock_qty: Number(item.variant[0].stock_qty),
                              hold_qty: Number(item.variant[0].hold_qty),
                              is_out_stock: item.variant[0].is_out_stock,
                              track_inventory: item.product_track_inventory,
                              published: item.published
                            })
                          } else {
                            this.commodity[idx].push({
                              id: item.id + ',' + item.variant[0].id + ',',
                              name: item.product_name + ' (' + item.variant[0].name + ')' + ' (Stock tidak mencukupi)',
                              disabled: true,
                              qty: Number(item.qty),
                              stock_qty: Number(item.variant[0].stock_qty),
                              hold_qty: Number(item.variant[0].hold_qty),
                              is_out_stock: item.variant[0].is_out_stock,
                              track_inventory: item.product_track_inventory,
                              published: item.published
                            })
                          }
                        } else {
                          this.commodity[idx].push({
                            id: item.id + ',' + item.product_variant_id + ',',
                            name: item.product_name + ' (' + item.variant[0].name + ')',
                            disabled: false,
                            qty: Number(item.qty),
                            stock_qty: Number(item.variant[0].stock_qty),
                            hold_qty: Number(item.variant[0].hold_qty),
                            is_out_stock: item.variant[0].is_out_stock,
                            track_inventory: item.product_track_inventory,
                            published: item.published
                          })
                        }
                      } else {
                        this.commodity[idx].push({
                          id: item.id + ',' + item.variant[0].id + ',',
                          name: item.product_name + ' (' + item.variant[0].name + ')' + ' (Stock tidak mencukupi)',
                          disabled: true,
                          qty: Number(item.qty),
                          stock_qty: Number(item.variant[0].stock_qty),
                          hold_qty: Number(item.variant[0].hold_qty),
                          is_out_stock: item.variant[0].is_out_stock,
                          track_inventory: item.product_track_inventory,
                          published: item.published
                        })
                      }
                    }
                  }
                } else {
                  if (item.variant.length > 0 && item.product_variant_id === 0) {
                    for (var b in item.variant) {
                      this.commodity[idx].push({
                        id: item.id + ',' + item.variant[b].id + ',',
                        name: item.product_name + ' (' + item.variant[b].name + ')',
                        disabled: false,
                        qty: Number(item.qty),
                        stock_qty: Number(item.variant[b].stock_qty),
                        hold_qty: Number(item.variant[b].hold_qty),
                        is_out_stock: item.variant[b].is_out_stock,
                        track_inventory: item.product_track_inventory,
                        published: item.published
                      })
                    }
                  } else {
                    const result = item.variant.find(obj => {
                      return obj.id === item.product_variant_id
                    })
                    this.commodity[idx].push({
                      id: item.id + ',' + item.product_variant_id + ',',
                      name: item.product_name + ' (' + result.name + ')',
                      disabled: false,
                      qty: Number(item.qty),
                      stock_qty: Number(result.stock_qty),
                      hold_qty: Number(result.hold_qty),
                      is_out_stock: result.is_out_stock,
                      track_inventory: item.product_track_inventory,
                      published: item.published
                    })
                  }
                }
              } else {
                if (!item.product_is_out_stock) {
                  if (item.product_track_inventory) {
                    if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                      const stock_incart = this.$stockCart(item.product_id, '_data_cart_OL-TAKE-AWAY')
                      if (Number(item.product_stock_qty) - Number(item.product_hold_qty) >= (Number(item.qty) + stock_incart)) {
                        this.commodity[idx].push({
                          id: item.id + ',' + ',',
                          name: item.product_name,
                          disabled: false,
                          qty: Number(item.qty),
                          stock_qty: Number(item.stock_qty),
                          hold_qty: Number(item.hold_qty),
                          is_out_stock: item.is_out_stock,
                          track_inventory: item.product_track_inventory,
                          published: item.published
                        })
                      } else {
                        this.commodity[idx].push({
                          id: item.id + ',' + ',',
                          name: item.product_name + ' (Stock tidak mencukupi)',
                          disabled: true,
                          qty: Number(item.qty),
                          stock_qty: Number(item.stock_qty),
                          hold_qty: Number(item.hold_qty),
                          is_out_stock: item.is_out_stock,
                          track_inventory: item.product_track_inventory,
                          published: item.published
                        })
                      }
                    } else {
                      this.commodity[idx].push({
                        id: item.id + ',' + ',',
                        name: item.product_name,
                        disabled: false,
                        qty: Number(item.qty),
                        stock_qty: Number(item.stock_qty),
                        hold_qty: Number(item.hold_qty),
                        is_out_stock: item.is_out_stock,
                        track_inventory: item.product_track_inventory,
                        published: item.published
                      })
                    }
                  } else {
                    this.commodity[idx].push({
                      id: item.id + ',' + ',',
                      name: item.product_name,
                      disabled: false,
                      qty: Number(item.qty),
                      stock_qty: Number(item.stock_qty),
                      hold_qty: Number(item.hold_qty),
                      is_out_stock: item.is_out_stock,
                      track_inventory: item.product_track_inventory,
                      published: item.published
                    })
                  }
                }
              }
              for (var i in item.children) {
                if (item.children[i].product_has_variant) {
                  if (item.children[i].product_track_inventory) {
                    if (item.children[i].variant.length > 0 && item.children[i].product_variant_id === 0) {
                      for (var x in item.children[i].variant) {
                        if (!item.children[i].variant[x].is_out_stock) {
                          if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                            const stock_incart = this.$stockCart(item.children[i].variant[x].id, '_data_cart_OL-TAKE-AWAY', 'variant')
                            if (Number(item.children[i].variant[x].stock_qty) - Number(item.children[i].variant[x].hold_qty) >= (Number(item.children[i].qty) + stock_incart)) {
                              this.commodity[idx].push({
                                id: item.children[i].parent_id + ',' + item.children[i].variant[x].id + ',' + item.children[i].id,
                                name: item.children[i].product_name + ' (' + item.children[i].variant[x].name + ')',
                                disabled: false,
                                qty: Number(item.children[i].qty),
                                stock_qty: Number(item.children[i].variant[x].stock_qty),
                                hold_qty: Number(item.children[i].variant[x].hold_qty),
                                is_out_stock: item.children[i].variant[x].is_out_stock,
                                track_inventory: item.children[i].product_track_inventory,
                                published: item.children[i].published
                              })
                            } else {
                              this.commodity[idx].push({
                                id: item.children[i].parent_id + ',' + item.children[i].variant[x].id + ',' + item.children[i].id,
                                name: item.children[i].product_name + ' (' + item.children[i].variant[x].name + ')' + ' (Stock tidak mencukupi)',
                                disabled: true,
                                qty: Number(item.children[i].qty),
                                stock_qty: Number(item.children[i].variant[x].stock_qty),
                                hold_qty: Number(item.children[i].variant[x].hold_qty),
                                is_out_stock: item.children[i].variant[x].is_out_stock,
                                track_inventory: item.children[i].product_track_inventory,
                                published: item.children[i].published
                              })
                            }
                          } else {
                            this.commodity[idx].push({
                              id: item.children[i].parent_id + ',' + item.children[i].variant[x].id + ',' + item.children[i].id,
                              name: item.children[i].product_name + ' (' + item.children[i].variant[x].name + ')',
                              disabled: false,
                              qty: Number(item.children[i].qty),
                              stock_qty: Number(item.children[i].variant[x].stock_qty),
                              hold_qty: Number(item.children[i].variant[x].hold_qty),
                              is_out_stock: item.children[i].variant[x].is_out_stock,
                              track_inventory: item.children[i].product_track_inventory,
                              published: item.children[i].published
                            })
                          }
                        } else {
                          this.commodity[idx].push({
                            id: item.children[i].parent_id + ',' + item.children[i].variant[x].id + ',' + item.children[i].id,
                            name: item.children[i].product_name + ' (' + item.children[i].variant[x].name + ')' + ' (Stock tidak mencukupi)',
                            disabled: true,
                            qty: Number(item.children[i].qty),
                            stock_qty: Number(item.children[i].variant[x].stock_qty),
                            hold_qty: Number(item.children[i].variant[x].hold_qty),
                            is_out_stock: item.children[i].variant[x].is_out_stock,
                            track_inventory: item.children[i].product_track_inventory,
                            published: item.children[i].published
                          })
                        }
                      }
                    } else {
                      const result = item.children[i].variant.find(obj => {
                        return obj.id === item.children[i].product_variant_id
                      })
                      if (typeof result !== 'undefined') {
                        if (!result.is_out_stock) {
                          if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                            const stock_incart = this.$stockCart(result.id, '_data_cart_OL-TAKE-AWAY', 'variant')
                            if (Number(result.stock_qty) - Number(result.hold_qty) >= (Number(item.children[i].qty) + stock_incart)) {
                              this.commodity[idx].push({
                                id: item.children[i].parent_id + ',' + item.children[i].product_variant_id + ',' + item.children[i].id,
                                name: item.children[i].product_name + ' (' + result.name + ')',
                                disabled: false,
                                qty: Number(item.children[i].qty),
                                stock_qty: Number(result.stock_qty),
                                hold_qty: Number(result.hold_qty),
                                is_out_stock: result.is_out_stock,
                                track_inventory: item.children[i].product_track_inventory,
                                published: item.children[i].published
                              })
                            } else {
                              this.commodity[idx].push({
                                id: item.children[i].parent_id + ',' + item.children[i].product_variant_id + ',' + item.children[i].id,
                                name: item.children[i].product_name + ' (' + result.name + ')' + ' (Stock tidak mencukupi)',
                                disabled: true,
                                qty: Number(item.children[i].qty),
                                stock_qty: Number(result.stock_qty),
                                hold_qty: Number(result.hold_qty),
                                is_out_stock: result.is_out_stock,
                                track_inventory: item.children[i].product_track_inventory,
                                published: item.children[i].published
                              })
                            }
                          } else {
                            this.commodity[idx].push({
                              id: item.children[i].parent_id + ',' + item.children[i].product_variant_id + ',' + item.children[i].id,
                              name: item.children[i].product_name + ' (' + result.name + ')',
                              disabled: false,
                              qty: Number(item.children[i].qty),
                              stock_qty: Number(result.stock_qty),
                              hold_qty: Number(result.hold_qty),
                              is_out_stock: result.is_out_stock,
                              track_inventory: item.children[i].product_track_inventory,
                              published: item.children[i].published
                            })
                          }
                        } else {
                          this.commodity[idx].push({
                            id: item.children[i].parent_id + ',' + item.children[i].product_variant_id + ',' + item.children[i].id,
                            name: item.children[i].product_name + ' (' + result.name + ')' + ' (Stock tidak mencukupi)',
                            disabled: true,
                            qty: Number(item.children[i].qty),
                            stock_qty: Number(result.stock_qty),
                            hold_qty: Number(result.hold_qty),
                            is_out_stock: result.is_out_stock,
                            track_inventory: item.children[i].product_track_inventory,
                            published: item.children[i].published
                          })
                        }
                      } else {
                        if (!item.children[i].variant[0].is_out_stock) {
                          if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                            const stock_incart = this.$stockCart(item.children[i].variant[0].id, '_data_cart_OL-TAKE-AWAY', 'variant')
                            if (Number(item.children[i].variant[0].stock_qty) - Number(item.children[i].variant[0].hold_qty) >= (Number(item.children[i].qty) + stock_incart)) {
                              this.commodity[idx].push({
                                id: item.children[i].parent_id + ',' + item.children[i].variant[0].id + ',' + item.children[i].id,
                                name: item.children[i].product_name + ' (' + item.children[i].variant[0].name + ')',
                                disabled: false,
                                qty: Number(item.children[i].qty),
                                stock_qty: Number(item.children[i].variant[0].stock_qty),
                                hold_qty: Number(item.children[i].variant[0].hold_qty),
                                is_out_stock: item.children[i].variant[0].is_out_stock,
                                track_inventory: item.children[i].product_track_inventory,
                                published: item.children[i].published
                              })
                            } else {
                              this.commodity[idx].push({
                                id: item.children[i].parent_id + ',' + item.children[i].variant[0].id + ',' + item.children[i].id,
                                name: item.children[i].product_name + ' (' + item.children[i].variant[0].name + ')' + ' (Stock tidak mencukupi)',
                                disabled: true,
                                qty: Number(item.children[i].qty),
                                stock_qty: Number(item.children[i].variant[0].stock_qty),
                                hold_qty: Number(item.children[i].variant[0].hold_qty),
                                is_out_stock: item.children[i].variant[0].is_out_stock,
                                track_inventory: item.children[i].product_track_inventory,
                                published: item.children[i].published
                              })
                            }
                          } else {
                            this.commodity[idx].push({
                              id: item.children[i].parent_id + ',' + item.children[i].variant[0].id + ',' + item.children[i].id,
                              name: item.children[i].product_name + ' (' + item.children[i].variant[0].name + ')',
                              disabled: false,
                              qty: Number(item.children[i].qty),
                              stock_qty: Number(item.children[i].variant[0].stock_qty),
                              hold_qty: Number(item.children[i].variant[0].hold_qty),
                              is_out_stock: item.children[i].variant[0].is_out_stock,
                              track_inventory: item.children[i].product_track_inventory,
                              published: item.children[i].published
                            })
                          }
                        } else {
                          this.commodity[idx].push({
                            id: item.children[i].parent_id + ',' + item.children[i].variant[0].id + ',' + item.children[i].id,
                            name: item.children[i].product_name + ' (' + item.children[i].variant[0].name + ')' + ' (Stock tidak mencukupi)',
                            disabled: true,
                            qty: Number(item.children[i].qty),
                            stock_qty: Number(item.children[i].variant[0].stock_qty),
                            hold_qty: Number(item.children[i].variant[0].hold_qty),
                            is_out_stock: item.children[i].variant[0].is_out_stock,
                            track_inventory: item.children[i].product_track_inventory,
                            published: item.children[i].published
                          })
                        }
                      }
                    }
                  } else {
                    if (item.children[i].variant.length > 0 && item.children[i].product_variant_id === 0) {
                      for (var y in item.children[i].variant) {
                        this.commodity[idx].push({
                          id: item.children[i].parent_id + ',' + item.children[i].variant[y].id + ',' + item.children[i].id,
                          name: item.children[i].product_name + ' (' + item.children[i].variant[y].name + ')',
                          disabled: false,
                          qty: Number(item.children[i].qty),
                          stock_qty: Number(item.children[i].variant[y].stock_qty),
                          hold_qty: Number(item.children[i].variant[y].hold_qty),
                          is_out_stock: item.children[i].variant[y].is_out_stock,
                          track_inventory: item.children[i].product_track_inventory,
                          published: item.children[i].published
                        })
                      }
                    } else {
                      const result = item.children[i].variant.find(obj => {
                        return obj.id === item.children[i].product_variant_id
                      })
                      this.commodity[idx].push({
                        id: item.children[i].parent_id + ',' + item.children[i].product_variant_id + ',' + item.children[i].id,
                        name: item.children[i].product_name + ' (' + result.name + ')',
                        disabled: false,
                        qty: Number(item.children[i].qty),
                        stock_qty: Number(result.stock_qty),
                        hold_qty: Number(result.hold_qty),
                        is_out_stock: result.is_out_stock,
                        track_inventory: item.children[i].product_track_inventory,
                        published: item.children[i].published
                      })
                    }
                  }
                } else {
                  if (!item.children[i].product_is_out_stock) {
                    if (item.children[i].product_track_inventory) {
                      if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                        const stock_incart = this.$stockCart(item.children[i].product_id, '_data_cart_OL-TAKE-AWAY')
                        if (Number(item.children[i].product_stock_qty) - Number(item.children[i].product_hold_qty) >= (Number(item.children[i].qty) + stock_incart)) {
                          this.commodity[idx].push({
                            id: item.children[i].parent_id + ',' + ',' + item.children[i].id,
                            name: item.children[i].product_name,
                            disabled: false,
                            qty: Number(item.children[i].qty),
                            stock_qty: Number(item.children[i].product_stock_qty),
                            hold_qty: Number(item.children[i].product_hold_qty),
                            is_out_stock: item.children[i].product_is_out_stock,
                            track_inventory: item.children[i].product_track_inventory,
                            published: item.children[i].published
                          })
                        } else {
                          this.commodity[idx].push({
                            id: item.children[i].parent_id + ',' + ',' + item.children[i].id,
                            name: item.children[i].product_name + ' (Stock tidak mencukupi)',
                            disabled: true,
                            qty: Number(item.children[i].qty),
                            stock_qty: Number(item.children[i].product_stock_qty),
                            hold_qty: Number(item.children[i].product_hold_qty),
                            is_out_stock: item.children[i].product_is_out_stock,
                            track_inventory: item.children[i].product_track_inventory,
                            published: item.children[i].published
                          })
                        }
                      } else {
                        this.commodity[idx].push({
                          id: item.children[i].parent_id + ',' + ',' + item.children[i].id,
                          name: item.children[i].product_name,
                          disabled: false,
                          qty: Number(item.children[i].qty),
                          stock_qty: Number(item.children[i].product_stock_qty),
                          hold_qty: Number(item.children[i].product_hold_qty),
                          is_out_stock: item.children[i].product_is_out_stock,
                          track_inventory: item.children[i].product_track_inventory,
                          published: item.children[i].published
                        })
                      }
                    } else {
                      this.commodity[idx].push({
                        id: item.children[i].parent_id + ',' + ',' + item.children[i].id,
                        name: item.children[i].product_name,
                        disabled: false,
                        qty: Number(item.children[i].qty),
                        stock_qty: Number(item.children[i].product_stock_qty),
                        hold_qty: Number(item.children[i].product_hold_qty),
                        is_out_stock: item.children[i].product_is_out_stock,
                        track_inventory: item.children[i].product_track_inventory,
                        published: item.children[i].published
                      })
                    }
                  }
                }
              }
            } else if (item.children.length === 0 && item.product_has_variant) {
              this.commodity[idx] = []
              if (item.product_variant_id) {
                const result = item.variant.find(obj => {
                  return obj.id === item.product_variant_id
                })
                this.combo_items.name[idx] = item.product_name + ' (' + result.name + ')'
                this.combo_items.stock_qty[idx] = Number(result.stock_qty)
                this.combo_items.hold_qty[idx] = Number(result.hold_qty)
                this.combo_items.is_out_stock[idx] = result.is_out_stock
                this.combo_items.id[idx] = item.id + ',' + item.product_variant_id + ','
              } else {
                this.combo_items.name[idx] = item.product_name + ' (' + item.variant[0].name + ')'
                this.combo_items.stock_qty[idx] = Number(item.variant[0].stock_qty)
                this.combo_items.hold_qty[idx] = Number(item.variant[0].hold_qty)
                this.combo_items.is_out_stock[idx] = item.variant[0].is_out_stock
                this.combo_items.id[idx] = item.id + ',' + item.variant[0].id + ','
              }
              this.combo_items.qty[idx] = Number(item.qty)
              this.combo_items.track_inventory[idx] = item.product_track_inventory
              if (item.product_track_inventory) {
                if (item.variant.length > 0 && item.product_variant_id === 0) {
                  for (var u in item.variant) {
                    if (!item.variant[u].is_out_stock) {
                      if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                        const stock_incart = this.$stockCart(item.variant[u].id, '_data_cart_OL-TAKE-AWAY', 'variant')
                        if (Number(item.variant[u].stock_qty) - Number(item.variant[u].hold_qty) >= (Number(item.qty) + stock_incart)) {
                          this.commodity[idx].push({
                            id: item.id + ',' + item.variant[u].id + ',',
                            name: item.product_name + ' (' + item.variant[u].name + ')',
                            disabled: false,
                            qty: Number(item.qty),
                            stock_qty: Number(item.variant[u].stock_qty),
                            hold_qty: Number(item.variant[u].hold_qty),
                            is_out_stock: item.variant[u].is_out_stock,
                            track_inventory: item.product_track_inventory,
                            published: item.published
                          })
                        } else {
                          this.commodity[idx].push({
                            id: item.id + ',' + item.variant[u].id + ',',
                            name: item.product_name + ' (' + item.variant[u].name + ')' + ' (Stock tidak mencukupi)',
                            disabled: true,
                            qty: Number(item.qty),
                            stock_qty: Number(item.variant[u].stock_qty),
                            hold_qty: Number(item.variant[u].hold_qty),
                            is_out_stock: item.variant[u].is_out_stock,
                            track_inventory: item.product_track_inventory,
                            published: item.published
                          })
                        }
                      } else {
                        this.commodity[idx].push({
                          id: item.id + ',' + item.variant[u].id + ',',
                          name: item.product_name + ' (' + item.variant[u].name + ')',
                          disabled: false,
                          qty: Number(item.qty),
                          stock_qty: Number(item.variant[u].stock_qty),
                          hold_qty: Number(item.variant[u].hold_qty),
                          is_out_stock: item.variant[u].is_out_stock,
                          track_inventory: item.product_track_inventory,
                          published: item.published
                        })
                      }
                    } else {
                      this.commodity[idx].push({
                        id: item.id + ',' + item.variant[u].id + ',',
                        name: item.product_name + ' (' + item.variant[u].name + ')' + ' (Stock tidak mencukupi)',
                        disabled: true,
                        qty: Number(item.qty),
                        stock_qty: Number(item.variant[u].stock_qty),
                        hold_qty: Number(item.variant[u].hold_qty),
                        is_out_stock: item.variant[u].is_out_stock,
                        track_inventory: item.product_track_inventory,
                        published: item.published
                      })
                    }
                  }
                } else {
                  const result = item.variant.find(obj => {
                    return obj.id === item.product_variant_id
                  })
                  if (typeof result !== 'undefined') {
                    if (!result.is_out_stock) {
                      if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                        const stock_incart = this.$stockCart(result.id, '_data_cart_OL-TAKE-AWAY', 'variant')
                        if (Number(result.stock_qty) - Number(result.hold_qty) >= (Number(item.qty) + stock_incart)) {
                          this.commodity[idx].push({
                            id: item.id + ',' + item.product_variant_id + ',',
                            name: item.product_name + ' (' + result.name + ')',
                            disabled: false,
                            qty: Number(item.qty),
                            stock_qty: Number(result.stock_qty),
                            hold_qty: Number(result.hold_qty),
                            is_out_stock: result.is_out_stock,
                            track_inventory: item.product_track_inventory,
                            published: item.published
                          })
                        } else {
                          this.commodity[idx].push({
                            id: item.id + ',' + item.product_variant_id + ',',
                            name: item.product_name + ' (' + result.name + ')' + ' (Stock tidak mencukupi)',
                            disabled: true,
                            qty: Number(item.qty),
                            stock_qty: Number(result.stock_qty),
                            hold_qty: Number(result.hold_qty),
                            is_out_stock: result.is_out_stock,
                            track_inventory: item.product_track_inventory,
                            published: item.published
                          })
                        }
                      } else {
                        this.commodity[idx].push({
                          id: item.id + ',' + item.product_variant_id + ',',
                          name: item.product_name + ' (' + result.name + ')',
                          disabled: false,
                          qty: Number(item.qty),
                          stock_qty: Number(result.stock_qty),
                          hold_qty: Number(result.hold_qty),
                          is_out_stock: result.is_out_stock,
                          track_inventory: item.product_track_inventory,
                          published: item.published
                        })
                      }
                    } else {
                      this.commodity[idx].push({
                        id: item.id + ',' + item.product_variant_id + ',',
                        name: item.product_name + ' (' + result.name + ')' + ' (Stock tidak mencukupi)',
                        disabled: true,
                        qty: Number(item.qty),
                        stock_qty: Number(result.stock_qty),
                        hold_qty: Number(result.hold_qty),
                        is_out_stock: result.is_out_stock,
                        track_inventory: item.product_track_inventory,
                        published: item.published
                      })
                    }
                  } else {
                    if (!item.variant[0].is_out_stock) {
                      if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                        const stock_incart = this.$stockCart(item.variant[0].id, '_data_cart_OL-TAKE-AWAY', 'variant')
                        if (Number(item.variant[0].stock_qty) - Number(item.variant[0].hold_qty) >= (Number(item.qty) + stock_incart)) {
                          this.commodity[idx].push({
                            id: item.id + ',' + item.variant[0].id + ',',
                            name: item.product_name + ' (' + item.variant[0].name + ')',
                            disabled: false,
                            qty: Number(item.qty),
                            stock_qty: Number(item.variant[0].stock_qty),
                            hold_qty: Number(item.variant[0].hold_qty),
                            is_out_stock: item.variant[0].is_out_stock,
                            track_inventory: item.product_track_inventory,
                            published: item.published
                          })
                        } else {
                          this.commodity[idx].push({
                            id: item.id + ',' + item.variant[0].id + ',',
                            name: item.product_name + ' (' + item.variant[0].name + ')' + ' (Stock tidak mencukupi)',
                            disabled: true,
                            qty: Number(item.qty),
                            stock_qty: Number(item.variant[0].stock_qty),
                            hold_qty: Number(item.variant[0].hold_qty),
                            is_out_stock: item.variant[0].is_out_stock,
                            track_inventory: item.product_track_inventory,
                            published: item.published
                          })
                        }
                      } else {
                        this.commodity[idx].push({
                          id: item.id + ',' + item.variant[0].id + ',',
                          name: item.product_name + ' (' + item.variant[0].name + ')',
                          disabled: false,
                          qty: Number(item.qty),
                          stock_qty: Number(item.variant[0].stock_qty),
                          hold_qty: Number(item.variant[0].hold_qty),
                          is_out_stock: item.variant[0].is_out_stock,
                          track_inventory: item.product_track_inventory,
                          published: item.published
                        })
                      }
                    } else {
                      this.commodity[idx].push({
                        id: item.id + ',' + item.variant[0].id + ',',
                        name: item.product_name + ' (' + item.variant[0].name + ')' + ' (Stock tidak mencukupi)',
                        disabled: true,
                        qty: Number(item.qty),
                        stock_qty: Number(item.variant[0].stock_qty),
                        hold_qty: Number(item.variant[0].hold_qty),
                        is_out_stock: item.variant[0].is_out_stock,
                        track_inventory: item.product_track_inventory,
                        published: item.published
                      })
                    }
                  }
                }
              } else {
                if (item.variant.length > 0 && item.product_variant_id === 0) {
                  for (var q in item.variant) {
                    this.commodity[idx].push({
                      id: item.id + ',' + item.variant[q].id + ',',
                      name: item.product_name + ' (' + item.variant[q].name + ')',
                      disabled: false,
                      qty: Number(item.qty),
                      stock_qty: Number(item.variant[q].stock_qty),
                      hold_qty: Number(item.variant[q].hold_qty),
                      is_out_stock: item.variant[q].is_out_stock,
                      track_inventory: item.product_track_inventory,
                      published: item.published
                    })
                  }
                } else {
                  const result = item.variant.find(obj => {
                    return obj.id === item.product_variant_id
                  })
                  if (typeof result !== 'undefined') {
                    if (result.is_out_stock) {
                      this.commodity[idx].push({
                        id: item.id + ',' + result.id + ',',
                        name: item.product_name + ' (' + result.name + ')',
                        disabled: true,
                        qty: Number(item.qty),
                        stock_qty: Number(result.stock_qty),
                        hold_qty: Number(result.hold_qty),
                        is_out_stock: result.is_out_stock,
                        track_inventory: item.product_track_inventory,
                        published: item.published
                      })
                    } else {
                      this.commodity[idx].push({
                        id: item.id + ',' + result.id + ',',
                        name: item.product_name + ' (' + result.name + ')',
                        disabled: false,
                        qty: Number(item.qty),
                        stock_qty: Number(result.stock_qty),
                        hold_qty: Number(result.hold_qty),
                        is_out_stock: result.is_out_stock,
                        track_inventory: item.product_track_inventory,
                        published: item.published
                      })
                    }
                  } else {
                    if (item.variant[0].is_out_stock) {
                      this.commodity[idx].push({
                        id: item.id + ',' + item.variant[0].id + ',',
                        name: item.product_name + ' (' + item.variant[0].name + ')',
                        disabled: true,
                        qty: Number(item.qty),
                        stock_qty: Number(item.variant[0].stock_qty),
                        hold_qty: Number(item.variant[0].hold_qty),
                        is_out_stock: item.variant[0].is_out_stock,
                        track_inventory: item.product_track_inventory,
                        published: item.published
                      })
                    } else {
                      this.commodity[idx].push({
                        id: item.id + ',' + item.variant[0].id + ',',
                        name: item.product_name + ' (' + item.variant[0].name + ')',
                        disabled: false,
                        qty: Number(item.qty),
                        stock_qty: Number(item.variant[0].stock_qty),
                        hold_qty: Number(item.variant[0].hold_qty),
                        is_out_stock: item.variant[0].is_out_stock,
                        track_inventory: item.product_track_inventory,
                        published: item.published
                      })
                    }
                  }
                }
              }
            }
          })
        } catch (e) {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
    },
    async showDetailProduct(item_product) {
      if (Number(item_product.is_out_stock) !== 1 && item_product.__cart_data.is_available !== false && !this.checkStockItem(item_product)) {
        this.resetForm()
        try {
          const { data } = await getDetailProduct(item_product.id)
          this.$store.state.loading_axios = false
          this.productDetails = data.data
          this.photo_product = data.data.photo_md
          if (this.productDetails.description) {
            this.html_description = (this.productDetails.description).replace(/\n/g, '<br />')
          } else {
            this.html_description = ''
          }
          if (data.data.predefined_order_notes) {
            const str = data.data.predefined_order_notes
            this.list_note = str.split(',')
          }
          this.sheetDetail = !this.sheetDetail
          document.querySelector('html').style.overflowY = 'hidden'
          if (this.productDetails.variants.length !== 0) {
            this.variant_group = []
            this.variant_alt_group = []
            const is_default = this.productDetails.variants.findIndex((e) => e.is_default === 1)
            if (is_default !== -1) {
              if (this.productDetails.has_material && !this.productDetails.track_inventory) {
                await this.checkStockMaterialObj({
                  product_variant_id: Number(this.productDetails.variants[is_default].id)
                })
              }
              if (this.productDetails.variants[is_default].all_photos.length > 0) {
                this.photo_product = this.productDetails.variants[is_default].photo_md
              }
              if (this.productDetails.track_inventory !== 0) {
                if (this.productDetails.variants[is_default].is_out_stock) {
                  this.variant_is_not_available = true
                } else {
                  if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                    const stock_incart = this.$stockCart(this.productDetails.variants[is_default].id, '_data_cart_OL-TAKE-AWAY', 'variant')
                    if ((Number(this.productDetails.variants[is_default].stock_qty) - Number(this.productDetails.variants[is_default].hold_qty)) >= Number(this.formProduct.qty) + stock_incart) {
                      this.variant_is_not_available = false
                    } else {
                      this.variant_is_not_available = true
                    }
                  } else {
                    this.variant_is_not_available = false
                  }
                }
              } else {
                this.variant_is_not_available = false
              }
              this.variant_group = this.productDetails.variants[is_default].name.split(',')
              this.formProduct.is_out_stock = this.productDetails.variants[is_default].is_out_stock
              this.formProduct.product_variant_id = this.productDetails.variants[is_default].id
              this.formProduct.product_variant_name = this.productDetails.variants[is_default].name
              this.formProduct.sell_price = parseFloat(this.productDetails.variants[is_default].sell_price)
              this.formProduct.stock_qty = this.productDetails.variants[is_default].stock_qty
              this.formProduct.hold_qty = this.productDetails.variants[is_default].hold_qty
            } else {
              for (var i = 0; i < this.productDetails.variant_tag.length; i++) {
                for (var x = 0; x < this.productDetails.variant_tag[i].detail.length; x++) {
                  this.variant_group[i] = this.productDetails.variant_tag[i].detail[0]
                }
              }
              const variant = this.productDetails.variants.findIndex((e) => e.name === this.variant_group.toString())
              if (variant !== -1) {
                if (this.productDetails.has_material && !this.productDetails.track_inventory) {
                  await this.checkStockMaterialObj({
                    product_variant_id: Number(this.productDetails.variants[variant].id)
                  })
                }
                if (this.productDetails.variants[variant].all_photos.length > 0) {
                  this.photo_product = this.productDetails.variants[variant].photo_md
                }
                if (this.productDetails.track_inventory !== 0) {
                  if (this.productDetails.variants[variant].is_out_stock) {
                    this.variant_is_not_available = true
                  } else {
                    if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                      const stock_incart = this.$stockCart(this.productDetails.variants[variant].id, '_data_cart_OL-TAKE-AWAY', 'variant')
                      if ((Number(this.productDetails.variants[variant].stock_qty) - Number(this.productDetails.variants[variant].hold_qty)) >= Number(this.formProduct.qty) + stock_incart) {
                        this.variant_is_not_available = false
                      } else {
                        this.variant_is_not_available = true
                      }
                    } else {
                      this.variant_is_not_available = false
                    }
                  }
                } else {
                  this.variant_is_not_available = false
                }
                this.formProduct.is_out_stock = this.productDetails.variants[variant].is_out_stock
                this.formProduct.product_variant_id = Number(this.productDetails.variants[variant].id)
                this.formProduct.product_variant_name = this.productDetails.variants[variant].name
                this.formProduct.sell_price = parseFloat(this.productDetails.variants[variant].sell_price)
                this.formProduct.stock_qty = this.productDetails.variants[variant].stock_qty
                this.formProduct.hold_qty = this.productDetails.variants[variant].hold_qty
                this.dialog.variantNotAvailable = false
                this.disable_add_cart = false
              } else {
                this.dialog.variantNotAvailable = true
                this.disable_add_cart = true
              }
            }
          } else {
            if (this.productDetails.has_material && !this.productDetails.track_inventory) {
              await this.checkStockMaterialObj({
                product_id: Number(item_product.id)
              })
            }
            this.formProduct.is_out_stock = this.productDetails.is_out_stock
            this.formProduct.sell_price = parseFloat(this.productDetails.sell_price)
            this.formProduct.stock_qty = this.productDetails.stock_qty
            this.formProduct.hold_qty = this.productDetails.hold_qty
          }
          this.sub_total = this.formProduct.sell_price
          this.formProduct.product_combo_id = null
          this.formProduct.product_id = item_product.id
          this.formProduct.qty = 1
          this.formProduct.name = this.productDetails.name
          this.formProduct.track_inventory = this.productDetails.track_inventory
          this.formProduct.klasifikasi_id = data.data.klasifikasi_id
          this.formProduct.non_taxable = this.productDetails.non_taxable
          this.formProduct.non_service_charge = this.productDetails.non_service_charge
          this.formProduct.has_material = this.productDetails.has_material
          this.formProduct.max_order = Number(this.productDetails.max_order)
          this.formProduct.min_order = Number(this.productDetails.min_order)
        } catch (e) {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
    },
    async syncProduct(item, type) {
      let sourceIds = this.inCartProductIds
      if (type === 'product_combo') {
        sourceIds = this.inCartComboIds
      }
      if (sourceIds.includes(item.id)) {
        let is_available = true
        if (item.has_variant === 0) {
          if (item.track_inventory !== 0) {
            if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
              if (Number(item.stock_qty) === this.countInCartMultipleSameIds(item.id, 'product')) {
                is_available = false
              } else {
                is_available = true
              }
            } else {
              is_available = true
            }
          }
        }
        item.__cart_data.note = this.noteExistOrNot(item.id, 'product')
        item.__cart_data.qty = this.countInCartMultipleSameIds(item.id, 'product')
        item.__cart_data.is_available = is_available
        if (type === 'product_combo') {
          item.__cart_data.note = this.noteExistOrNot(item.id)
          item.__cart_data.qty = this.countInCartMultipleSameIds(item.id)
        }
      }
    },
    countInCartMultipleSameIds(itemId, type = 'product_combo') {
      return this.dataInCart.item.filter(inCartItem => {
        return inCartItem[type + '_id'] === itemId
      }).reduce((acc, curr) => {
        return acc + curr.qty
      }, 0)
    },
    noteExistOrNot(itemId, type = 'product_combo') {
      const noteExist = this.dataInCart.item.filter(inCartItem => {
        return inCartItem[type + '_id'] === itemId
      })
      const idx = noteExist.findIndex((e) => e.note !== '')
      if (idx !== -1) {
        return noteExist[idx].note
      }
    },
    getCartItemIdentity(item) {
      const addonsKey = (item.addons || [])
        .map(a => `${a.product_addon_id}-${a.product_addon_variant_id || ''}`)
        .sort()
        .join(',')
      const comboItemsKey = (item.product_combo_items || [])
        .map(c => `${c.id}-${c.children_id || ''}-${c.variant_id || ''}`)
        .sort()
        .join(',')
      return [
        item.product_id,
        item.product_combo_id,
        item.product_variant_id,
        item.note || '',
        addonsKey,
        comboItemsKey
      ].join('|')
    },
    findExistingCartItem(item) {
      const identity = this.getCartItemIdentity(item)
      return this.dataInCart.item.find(cartItem => this.getCartItemIdentity(cartItem) === identity)
    },
    async addToCartFinally(itemType) {
      const existingItem = this.findExistingCartItem(this.formProduct)
      if (existingItem) {
        existingItem.qty = Number(existingItem.qty) + Number(this.formProduct.qty)
        existingItem.sub_total = Number(existingItem.sub_total) + Number(this.formProduct.sub_total)
        if (existingItem.materials && existingItem.materials.length) {
          existingItem.materials.forEach((material, idx) => {
            if (this.formProduct.materials[idx]) {
              material.qty_in_cart = Number(material.qty_in_cart) + Number(this.formProduct.materials[idx].qty_in_cart)
            }
          })
        }
      } else {
        await this.dataInCart.item.push({ ...this.formProduct })
      }
      if (itemType === 'product_combo') {
        this.datacombos.map(item => {
          if (item.id === this.formProduct.product_combo_id) {
            item.__cart_data.note = this.noteExistOrNot(item.id)
            item.__cart_data.qty = this.countInCartMultipleSameIds(item.id)
          }
        })
      } else if (itemType === 'product') {
        const selectedProductGroup = await this.productGroup.filter(item => {
          return item.product_group_id === this.formProduct.klasifikasi_id
        })
        if (selectedProductGroup.length) {
          await selectedProductGroup[0].items.map(async item => {
            if (item.id === this.formProduct.product_id) {
              let is_available = true
              if (item.has_variant === 0) {
                if (item.track_inventory !== 0) {
                  if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                    if (Number(item.stock_qty) === this.countInCartMultipleSameIds(item.id, 'product')) {
                      is_available = false
                    } else {
                      is_available = true
                    }
                  } else {
                    is_available = true
                  }
                }
              }
              item.__cart_data.note = this.noteExistOrNot(item.id, 'product')
              item.__cart_data.qty = this.countInCartMultipleSameIds(item.id, 'product')
              item.__cart_data.is_available = is_available
            }
          })
        }

        const selectedProductGroupSearch = await this.productSearch.filter(item => {
          return item.product_group_id === this.formProduct.klasifikasi_id
        })
        if (selectedProductGroupSearch.length) {
          await selectedProductGroupSearch[0].items.map(async item => {
            if (item.id === this.formProduct.product_id) {
              let is_available = true
              if (item.has_variant === 0) {
                if (item.track_inventory !== 0) {
                  if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                    if (Number(item.stock_qty) === this.countInCartMultipleSameIds(item.id, 'product')) {
                      is_available = false
                    } else {
                      is_available = true
                    }
                  } else {
                    is_available = true
                  }
                }
              }
              item.__cart_data.note = this.noteExistOrNot(item.id, 'product')
              item.__cart_data.qty = this.countInCartMultipleSameIds(item.id, 'product')
              item.__cart_data.is_available = is_available
            }
          })
        }
      }
      await this.$store.dispatch('saveDataCartTakeAway', this.dataInCart)
    },
    async addCartProduct() {
      const result = this.$canOrder(
        this.formProduct.product_combo_id || this.formProduct.product_id,
        this.formProduct.qty,
        this.productDetails.min_order,
        this.productDetails.max_order,
        '_data_cart_OL-TAKE-AWAY'
      )

      if (!result.valid) {
        this.orderErrorMessage = result.message
        this.dialog.maxMinOrder = true
        return
      }

      let itemType = 'product'
      if (this.formProduct.product_combo_id) {
        itemType = 'product_combo'
      }

      this.formProduct.addons = this.formProduct.addons.filter(function(el) {
        return el != null
      })

      if (this.formProduct.addons.length > 0) {
        for (let i = 0; i < this.formProduct.addons.length; i++) {
          const checkAddons = this.checkStockAddons(this.formProduct.addons[i], true)
          if (checkAddons.valid) {
            this.sub_total = this.sub_total + (this.formProduct.addons[i].product_addon_price * this.formProduct.qty)
          } else {
            this.unavailable_product = checkAddons.product_name
            this.dialog.isOutStock = true
            return
          }
        }
      }

      if (this.formProduct.materials.length > 0) {
        for (let i = 0; i < this.formProduct.materials.length; i++) {
          this.formProduct.materials[i].qty_in_cart = Number(this.formProduct.qty) * Number(this.formProduct.materials[i].qty)
        }
      }

      const subTotal = this.sub_total
      this.formProduct.sub_total = subTotal

      const LOCAL_DATA_CartTakeAway = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_OL-TAKE-AWAY')
      if (LOCAL_DATA_CartTakeAway) {
        this.dataInCart = JSON.parse(LOCAL_DATA_CartTakeAway)
      }

      if (this.formProduct.product_combo_id) {
        let product_available = true
        let product_unpublished = false
        let unavailable_product = ''
        if (this.combo_items && this.combo_items.id.length) {
          for (var i in this.combo_items.id) {
            const str = this.combo_items.id[i]
            const item_id = str.split(',')
            if (this.combo_items.published[i]) {
              if (!this.combo_items.is_out_stock[i]) {
                if (this.combo_items.track_inventory[i]) {
                  if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                    if (Number(item_id[1])) {
                      if (Number(this.combo_items.stock_qty[i]) - Number(this.combo_items.hold_qty[i]) < ((Number(this.combo_items.qty[i]) * this.formProduct.qty) + this.$stockCart(item_id[1], '_data_cart_OL-TAKE-AWAY', 'variant'))) {
                        product_available = false
                        unavailable_product = this.combo_items.name[i]
                        break
                      }
                    } else {
                      if (Number(this.combo_items.stock_qty[i]) - Number(this.combo_items.hold_qty[i]) < ((Number(this.combo_items.qty[i]) * this.formProduct.qty) + this.$stockCart(item_id[0], '_data_cart_OL-TAKE-AWAY'))) {
                        product_available = false
                        unavailable_product = this.combo_items.name[i]
                        break
                      }
                    }
                  }
                }
              } else {
                product_available = false
                unavailable_product = this.combo_items.name[i]
                break
              }
            } else {
              product_available = false
              product_unpublished = true
              unavailable_product = this.combo_items.name[i]
              break
            }
            this.formProduct.product_combo_items.push({
              id: item_id[0],
              children_id: item_id[2] !== '' ? item_id[2] : null,
              name: this.combo_items.name[i],
              variant_id: item_id[1],
              qty: Number(this.combo_items.qty[i]),
              stock_qty: Number(this.combo_items.stock_qty[i]),
              hold_qty: Number(this.combo_items.hold_qty[i]),
              track_inventory: this.combo_items.track_inventory[i]
            })
          }
        }

        if (product_available) {
          await this.validateStockMaterial().then(async(data) => {
            if (data.valid) {
              await this.addToCartFinally(itemType)
              this.closeShowDetail()
            } else {
              this.unavailable_product = data.message
              this.dialog.product_unpublished = true
            }
          })
        } else if (product_unpublished) {
          this.unavailable_product = unavailable_product
          this.dialog.product_unpublished = true
        } else {
          this.unavailable_product = unavailable_product
          this.error_from_validate = 0
          this.dialog.qtyCheck = true
        }
      } else {
        if (Number(this.formProduct.product_variant_id)) {
          const variantCart = this.productDetails.variants.find(x => x.id === Number(this.formProduct.product_variant_id))
          if (variantCart.is_out_stock) {
            this.dialog.isOutStock = true
          } else {
            if (this.formProduct.track_inventory === 1 && this.$store.state.selected_outlet.pos_disallow_sell_no_stock && (this.$stockCart(this.formProduct.product_variant_id, '_data_cart_OL-TAKE-AWAY', 'variant') + this.formProduct.qty) > (Number(this.formProduct.stock_qty) - Number(this.formProduct.hold_qty))) {
              this.error_from_validate = 0
              this.dialog.qtyCheck = true
            } else {
              let valid = true
              await this.validateStockMaterial().then((data) => {
                valid = data.valid
                this.error_from_validate = 1
                this.error_string_from_validate = data.message
                this.dialog.qtyCheck = !data.valid
                if (!data.valid) {
                  return
                }
              })
              if (valid) {
                await this.addToCartFinally(itemType)
                this.closeShowDetail()
              }
            }
          }
        } else {
          if (this.formProduct.is_out_stock) {
            this.dialog.isOutStock = true
          } else {
            if (this.formProduct.track_inventory === 1 && this.$store.state.selected_outlet.pos_disallow_sell_no_stock && (this.$stockCart(this.formProduct.product_id, '_data_cart_OL-TAKE-AWAY') + this.formProduct.qty) > (Number(this.formProduct.stock_qty) - Number(this.formProduct.hold_qty))) {
              this.error_from_validate = 0
              this.dialog.qtyCheck = true
            } else {
              let valid = true
              await this.validateStockMaterial().then((data) => {
                valid = data.valid
                this.error_from_validate = 1
                this.error_string_from_validate = data.message
                this.dialog.qtyCheck = !data.valid
                if (!data.valid) {
                  return
                }
              })
              if (valid) {
                await this.addToCartFinally(itemType)
                this.closeShowDetail()
              }
            }
          }
        }
      }
    },
    searchProduct: debounce(async function(val) {
      if (val === null) {
        val = ''
      }
      this.search_text = val
      this.datacombos = []
      this.productGroup = []
      this.productSearch = []
      if (val !== '') {
        this.settingScroll.product = true
        this.settingScroll.combo = true
        this.params.page = 1
        this.params.per_page = 20
        this.searching = true
        await this.loadDataSearch()
      } else {
        this.settingScroll.search = true
        this.params.page = 1
        this.params.per_page = 20
        this.params.combo_page = 1
        this.params.combo_per_page = 20
        this.searching = false
        await this.loadGroupProduct()
        await this.loadProductCombo()
      }
    }, 1000),
    async loadDataSearch() {
      if (this.searching === true && this.search_text !== null) {
        try {
          this.loading = true
          const params = {
            page: this.params.page++,
            per_page: this.params.per_page,
            search_text: this.search_text,
            search_operator: 'like',
            search_column: 'name'
          }
          const { data } = await getDataProduct(params)
          this.settingScroll.search = (data.data.length < this.params.per_page)
          this.$store.state.loading_axios = false
          const data_product = data.data
          await data_product.map(item => {
            let is_available = true
            if (item.has_variant === 0) {
              if (item.track_inventory !== 0) {
                if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                  if (Number(item.stock_qty) <= 0) {
                    is_available = false
                  } else {
                    is_available = true
                  }
                } else {
                  is_available = true
                }
              }
            }
            this.$set(item, '__cart_data', { qty: 0, note: '', is_available: is_available })
            this.syncProduct(item)
            if (!this.loadedProductSearchIds.includes(item.klasifikasi_id)) {
              this.productSearch.push({
                product_group_id: item.klasifikasi_id,
                product_group_name: item.klasifikasi,
                items: data_product.filter(__data => __data.klasifikasi_id === item.klasifikasi_id)
              })
            } else {
              const productSearch = this.productSearch.filter(group => {
                return item.klasifikasi_id === group.product_group_id
              })
              const index = productSearch[0].items.findIndex((e) => e.id === item.id)
              if (index === -1) {
                productSearch[0].items.push(...data_product.filter(__data => __data.klasifikasi_id === item.klasifikasi_id))
              }
            }
          })
        } catch (e) {
          this.productSearch = []
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        } finally {
          this.loading = false
        }
      }
    },
    async validateStockMaterial() {
      const obj = {
        valid: true,
        message: ''
      }
      try {
        const temp_item = { ...this.formProduct }
        const existingIndex = this.dataInCart.item.findIndex((e) => this.getCartItemIdentity(e) === this.getCartItemIdentity(temp_item))
        if (existingIndex === -1) {
          this.temp_cart.item = [...this.dataInCart.item, temp_item]
        } else {
          const mergedItem = { ...this.dataInCart.item[existingIndex] }
          mergedItem.qty = Number(mergedItem.qty) + Number(temp_item.qty)
          if (mergedItem.materials && mergedItem.materials.length && temp_item.materials && temp_item.materials.length) {
            mergedItem.materials = mergedItem.materials.map((material) => {
              const newMaterial = temp_item.materials.find((m) => m.material_product_id === material.material_product_id)
              return {
                ...material,
                qty_in_cart: Number(material.qty_in_cart) + Number(newMaterial ? newMaterial.qty_in_cart : 0)
              }
            })
          }
          this.temp_cart.item = [
            ...this.dataInCart.item.slice(0, existingIndex),
            mergedItem,
            ...this.dataInCart.item.slice(existingIndex + 1)
          ]
        }
        await validateMaterial(this.temp_cart)
        this.$store.state.loading_axios = false
        return obj
      } catch (e) {
        this.formProduct.product_combo_items = []
        delete this.temp_cart.item
        obj.valid = false
        obj.message = e.string
        return obj
      }
    },
    async selectVariant() {
      const variant = this.productDetails.variants.findIndex((e) => e.name === this.variant_group.toString())
      if (variant !== -1) {
        if (this.productDetails.has_material && !this.productDetails.track_inventory) {
          await this.checkStockMaterialObj({
            product_variant_id: Number(this.productDetails.variants[variant].id)
          })
        }
        if (this.productDetails.variants[variant].all_photos.length > 0) {
          this.photo_product = this.productDetails.variants[variant].photo_md
        } else {
          this.photo_product = this.productDetails.photo_md
        }
        if (this.productDetails.track_inventory !== 0) {
          if (this.productDetails.variants[variant].is_out_stock) {
            this.variant_is_not_available = true
          } else {
            if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
              const stock_incart = this.$stockCart(this.productDetails.variants[variant].id, '_data_cart_OL-TAKE-AWAY', 'variant')
              if ((Number(this.productDetails.variants[variant].stock_qty) - Number(this.productDetails.variants[variant].hold_qty)) >= Number(this.formProduct.qty) + stock_incart) {
                this.variant_is_not_available = false
              } else {
                this.variant_is_not_available = true
              }
            } else {
              this.variant_is_not_available = false
            }
          }
        } else {
          this.variant_is_not_available = false
        }
        this.formProduct.is_out_stock = this.productDetails.variants[variant].is_out_stock
        this.formProduct.product_variant_id = Number(this.productDetails.variants[variant].id)
        this.formProduct.product_variant_name = this.productDetails.variants[variant].name
        this.formProduct.sell_price = parseFloat(this.productDetails.variants[variant].sell_price)
        this.formProduct.stock_qty = this.productDetails.variants[variant].stock_qty
        this.formProduct.hold_qty = this.productDetails.variants[variant].hold_qty
        this.formProduct.addons = []
        this.sub_total = this.formProduct.sell_price * this.formProduct.qty
        this.added_addons = []
        this.dialog.variantNotAvailable = false
        this.disable_add_cart = false
      } else {
        this.dialog.variantNotAvailable = true
        this.disable_add_cart = true
      }
    },
    selectComboItem(idx) {
      const item = this.commodity[idx].findIndex((e) => e.id === this.combo_items.id[idx])
      this.combo_items.name[idx] = this.commodity[idx][item].name
      this.combo_items.qty[idx] = this.commodity[idx][item].qty
      this.combo_items.stock_qty[idx] = this.commodity[idx][item].stock_qty
      this.combo_items.hold_qty[idx] = this.commodity[idx][item].hold_qty
      this.combo_items.is_out_stock[idx] = this.commodity[idx][item].is_out_stock
      this.combo_items.track_inventory[idx] = this.commodity[idx][item].track_inventory
      this.combo_items.published[idx] = this.commodity[idx][item].published
    },
    checkStockAddons(item, atCart = false) {
      const obj = {
        valid: true,
        product_name: ''
      }
      let stockAddonsInCart = 0
      const _selected_type = this.$store.state.selected_type
      if (item.track_inventory) {
        if (!item.is_out_stock) {
          if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
            if (atCart) {
              if (!item.product_addon_variant_id) {
                stockAddonsInCart = this.$stockCart(item.product_addon_product_id, '_data_cart_' + _selected_type)
              } else {
                stockAddonsInCart = this.$stockCart(item.product_addon_variant_id, '_data_cart_' + _selected_type, 'variant')
              }
              if ((stockAddonsInCart + (Number(this.formProduct.qty) * Number(item.product_addon_qty))) > Number(item.product_addon_stock)) {
                obj.product_name = item.product_addon_name
                obj.valid = false
              }
            } else {
              if (!item.variant_id) {
                stockAddonsInCart = this.$stockCart(item.product_id, '_data_cart_' + _selected_type)
              } else {
                stockAddonsInCart = this.$stockCart(item.variant_id, '_data_cart_' + _selected_type, 'variant')
              }
              if ((stockAddonsInCart + (Number(this.formProduct.qty) * Number(item.product_qty))) > Number(item.stock_qty)) {
                obj.product_name = item.name
                obj.valid = false
              }
            }
          }
        }
      }
      return obj
    },
    addProductAddons(item, idx) {
      const checkAddons = this.checkStockAddons(item)
      if (checkAddons.valid) {
        this.$set(this.added_addons, [item.id], true)
        const dataAddons = {
          product_addon_id: item.id,
          product_addon_name: item.name,
          product_addon_price: Number((item.total_price != null ? item.total_price : item.price)),
          product_addon_product_id: item.product_id,
          product_addon_variant_id: item.variant_id,
          product_addon_stock: item.stock_qty,
          product_addon_qty: item.product_qty,
          track_inventory: item.track_inventory,
          is_out_stock: item.is_out_stock
        }
        this.formProduct.addons[idx] = dataAddons
      } else {
        this.unavailable_product = checkAddons.product_name
        this.dialog.isOutStock = true
      }
    },
    removeProductAddons(id, price, idx) {
      this.$set(this.added_addons, [id], false)
      const arrayAddons = this.formProduct.addons
      arrayAddons.splice(idx, 1)
    },
    plus() {
      this.formProduct.qty = this.formProduct.qty + 1
      this.sub_total = this.sub_total + this.formProduct.sell_price
    },
    minus() {
      this.formProduct.qty = this.formProduct.qty - 1
      this.sub_total = this.sub_total - this.formProduct.sell_price
    },
    goBack() {
      const astra_outlet = this.$store.state.store_astra
      const url_id = this.$store.state.url_domain
      if (astra_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://zestloungemenaraastra.myolsera.com'
      } else {
        this.$router.push({ name: 'take_away' }).catch(() => {})
      }
    },
    closeShowDetail() {
      this.sheetDetail = false
      document.querySelector('html').style.overflowY = 'scroll'
    },
    async clearSearchData() {
      await this.searchProduct()
    },
    resetForm() {
      this.added_addons = []
      this.formProduct.product_id = null
      this.formProduct.product_variant_id = null
      this.formProduct.product_variant_name = null
      this.formProduct.addons = []
      this.formProduct.product_combo_id = null
      this.formProduct.product_combo_items = []
      this.formProduct.qty = 1
      this.formProduct.note = ''
      this.formProduct.has_material = 0
      this.formProduct.materials = []
      this.combo_items.id = []
      this.combo_items.name = []
      this.combo_items.qty = []
      this.combo_items.stock_qty = []
      this.combo_items.hold_qty = []
      this.combo_items.is_out_stock = []
      this.combo_items.track_inventory = []
      this.list_note = []
      this.sub_total = 0
    },
    noteOnFocus() {
      if (/Android|webOS|iPhone|iPad|Mac|Macintosh|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        const windowHeightSeventyPercent = parseInt(screen.height * 0.7)
        document.querySelector('.v-dialog.product__detail').style.height = windowHeightSeventyPercent + 'px'
      }
    },
    noteOnBlur() {
      if (/Android|webOS|iPhone|iPad|Mac|Macintosh|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        document.querySelector('.v-dialog.product__detail').style.height = '100%'
      }
    },
    checkStockItem(item) {
      if (!item.has_variant) {
        if (item.track_inventory) {
          if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
            if (Number(item.hold_qty) > Number(item.stock_qty)) {
              return true
            } else {
              return false
            }
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    openDialogNote() {
      this.dialog.list_note = true
      this.listnote = []
    },
    saveNote() {
      for (let i = 0; i < this.list_note.length; i++) {
        if (this.listnote[i]) {
          if (i === 0 && this.formProduct.note === '') {
            this.formProduct.note = this.list_note[i]
          } else {
            this.formProduct.note = this.formProduct.note + ', ' + this.list_note[i]
          }
        }
      }
      this.dialog.list_note = false
    },
    async checkStockMaterialObj(objId) {
      const requestId = ++this.materialRequestId
      try {
        const { data } = await checkStockMaterial(objId)
        this.$store.state.loading_axios = false
        if (requestId !== this.materialRequestId) return
        this.formProduct.materials = data.data.materials
      } catch (e) {
        if (requestId !== this.materialRequestId) return
        this.formProduct.materials = []
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    checkStockMaterials() {
      let is_available = true
      if (this.formProduct.materials.length > 0) {
        for (let m = 0; m < this.formProduct.materials.length; m++) {
          if (this.formProduct.materials[m].product_out_stock) {
            this.dialog.isOutStock = true
            is_available = false
            break
          } else {
            if (this.formProduct.materials[m].material_product_variant_id) {
              if (Number(this.formProduct.materials[m].track_inventory) === 1) {
                if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                  if (this.$stockCart(this.formProduct.materials[m].material_product_variant_id, '_data_cart_OL-TAKE-AWAY', 'variant') + (this.formProduct.qty * Number(this.formProduct.materials[m].qty)) > (Number(this.formProduct.materials[m].product_stock_qty) - Number(this.formProduct.materials[m].product_hold_qty))) {
                    this.dialog.isOutStock = true
                    is_available = false
                    break
                  }
                }
              }
            } else {
              if (Number(this.formProduct.materials[m].track_inventory) === 1) {
                if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                  if (this.$stockCart(this.formProduct.materials[m].material_product_id, '_data_cart_OL-TAKE-AWAY') + (this.formProduct.qty * Number(this.formProduct.materials[m].qty)) > (Number(this.formProduct.materials[m].product_stock_qty) - Number(this.formProduct.materials[m].product_hold_qty))) {
                    this.dialog.isOutStock = true
                    is_available = false
                    break
                  }
                }
              }
            }
          }
        }
      }
      return is_available
    }
  }
}
</script>
